export default {
  user: {
    name: '',
    profile: { title: 'ข้อมูลส่วนตัว' },
    setting: { title: 'การตั้งค่า' },
    change_password: { title: 'เปลี่ยนรหัสผ่าน' },
  },
}
